<div class="inner-container bg-white section-gap-lg not-available-page">
  <div class="container">
    <div fxLayout="row wrap" fxLayoutAlign="center center">
      <div
        fxFlex.xs="100"
        fxFlex.sm="100"
        fxFlex.md="80"
        fxFlex.lg="40"
        fxFlex.xl="40"
      >
        <mat-card class="text-center pb-5">
          <mat-icon class="material-icons fav-icon"    alt="hdie-source-empty">
            hide_source
          </mat-icon>
          <h5 class="mb-3">{{ 'notAvailable.text' | translate }}</h5>
          <button
            mat-raised-button
            class="button-lg w-100 bg-primary"
            color="accent"
            [routerLink]="['/' + lang + '/']"
          >
            {{ 'notAvailable.goToHome' | translate }}
          </button>
        </mat-card>
      </div>
    </div>
  </div>
</div>
